export default {
      id: "about-symbols-01-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-01",
      toString: function () {
        return this.url;
      }
    }